/**
 * External Systems API client (P3-C Doc 38).
 */
import { api } from "./client";

export type SystemType = "git" | "url" | "database" | "rest_api";
export type SyncStatus = "idle" | "syncing" | "done" | "error";

export interface ExternalSystem {
  id: string;
  type: SystemType;
  slug: string;
  name: string;
  description: string | null;
  config: Record<string, unknown>;
  credentials_secret_name: string | null;
  sync_status: SyncStatus;
  last_synced_at: string | null;
  last_error: string | null;
  doc_metadata: Record<string, unknown>;
  has_doc: boolean;
  updated_at: string;
  created_at: string;
}

export interface ExternalSystemDetail extends ExternalSystem {
  generated_doc: string | null;
}

export interface ExternalSystemListResponse {
  items: ExternalSystem[];
}

export interface CreateRequest {
  type: SystemType;
  slug: string;
  name: string;
  description?: string | null;
  config: Record<string, unknown>;
  credentials_secret_name?: string | null;
}

export interface UpdateRequest {
  name?: string | null;
  description?: string | null;
  config?: Record<string, unknown> | null;
  credentials_secret_name?: string | null;
}

export interface SyncResponse {
  sync_status: SyncStatus;
  last_synced_at: string | null;
  last_error: string | null;
  doc_metadata: Record<string, unknown>;
}

export const externalSystemsApi = {
  list: () =>
    api.get<ExternalSystemListResponse>("/api/v1/admin/external-systems"),
  create: (body: CreateRequest) =>
    api.post<ExternalSystem>("/api/v1/admin/external-systems", body),
  get: (id: string) =>
    api.get<ExternalSystemDetail>(
      `/api/v1/admin/external-systems/${encodeURIComponent(id)}`,
    ),
  update: (id: string, body: UpdateRequest) =>
    api.patch<ExternalSystem>(
      `/api/v1/admin/external-systems/${encodeURIComponent(id)}`,
      body,
    ),
  delete: (id: string) =>
    api.delete<void>(
      `/api/v1/admin/external-systems/${encodeURIComponent(id)}`,
    ),
  sync: (id: string) =>
    api.post<SyncResponse>(
      `/api/v1/admin/external-systems/${encodeURIComponent(id)}/sync`,
    ),
};
